module.exports = __webpack_public_path__ + "static/media/user.01ec8874.png";